// The per-character rep target already shown on the kana/kanji writing
// practice pages themselves (see PracticeProgress). Shared here so the
// homepage's "Continue learning" progress ring stays in sync with that
// same definition of "practiced" rather than drifting from it.
export const PRACTICE_GOAL = 100;
